import { Observable, observe, Scope } from 'wdc-cube'
import { ResultadoAnaliseRow } from '../bordero.types'
import { WaitingScope } from 'src/components/waiting/waiting.scopes'

@Observable
export class ResultadoAnaliseScope extends Scope {
    @observe() waiting?: WaitingScope
    @observe() resultados = {} as Record<string, ResultadoAnaliseRow[]>

    onClose = Scope.ASYNC_ACTION
}

export default ResultadoAnaliseScope
